import { BehaviorSubject } from "rxjs";
import { PrivacyComponent } from "./../privacy/privacy.component";
import { GlobalServiceService } from "src/app/services/global-service.service";
import { LocalstorageService } from "./../../services/localstorage.service";
import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { LoginService } from "../../login.service";
import { Location } from "@angular/common";
import { MatDialog, MatSnackBar } from "@angular/material";
import { MessageDialogComponent } from "../../share/message-dialog/message-dialog.component";
import { ChangePassComponent } from "../../components/navbar/change-pass/change-pass.component";
import { UsersService } from "../../users/users.service";
import { ApiBasic } from "../../services/api-basic";
import Swal from "sweetalert2";

import * as moment from "moment";
import { NotificacionesService } from "../../components/notificaciones.service";
import { FormGroup, FormControl, Validators } from '@angular/forms';
moment.locale("es");

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
  host: { class: "fullPage" },
})
export class LoginComponent implements OnInit {
  @ViewChild("loginForm") form: any;
  @ViewChild("recoveryForm") recoverForm: any;
  userLoginData: {
    username: string;
    password: string;
  };
  hidePassword: boolean = true;
  device_info: any;
  showError = false;
  loading = true;
  showAssist = false;
  showRecovery = false;
  msg: string;
  loadinGral: boolean = false;
  msgError: any = "Usuario o contraseña invalida";
  infoUser: any;
  interval;
  interval2;

  flagPrivacy: boolean = false;
  flagInicio: boolean = true;

  loginform: FormGroup;
  constructor(
    public app: GlobalServiceService,
    private router: Router,
    private login: LoginService,
    private _location: Location,
    public userService: UsersService,
    public apiBasic: ApiBasic,
    public dialog: MatDialog,
    public _login: LoginService,
    public _localstorage: LocalstorageService,
    public snackBar: MatSnackBar,
    public _global: GlobalServiceService,
    public _firebase: NotificacionesService
  ) {
    this.userLoginData = {
      username: "",
      password: "",
    };
  }

  recoverPassword() {
    this.loading = true;
    this.msg = "";
    this.login
      .recoverPassword({ username: this.recoverForm.value.mail })
      .subscribe((res: any) => {
        this.loading = false;
        if (res.success) {
          this.recoverForm.reset();
          this.msg =
            "Tu password ha sido actualizado con exito, Utiliza tu password de default para ingresar de nuevo";
        } else {
          this.msg = res.msg;
        }
      });
  }

  recargar() {
    window.location.reload();
  }
  ngOnInit() {
    this.device_info = {
      device: "web",
      device_model: null,
      device_os: null,
      device_os_version: null,
      navigator: "Codova",
    };
    this.app.setLogged(false);

    // if (!this.apiBasic.base_url) {
    //   if (this.interval2 != undefined) {
    //     clearInterval(this.interval2);
    //   }
    //   this.interval2 = setInterval(
    //     this.recargar.bind(this),
    //     2000
    //   );
    // }


    // this.loginform = new FormGroup(
    //   {
    //     pass_new: new FormControl("", [
    //       Validators.required,
    //       Validators.pattern(
    //         "(?=\\D*\\d)(?=[^a-z]*[a-z])(?=[^A-Z]*[A-Z])(?=.*[!@$%&_]).{8,}"
    //       ),
    //     ]),
    //     pass_new_confirm: new FormControl("", [
    //       Validators.required,
    //       Validators.minLength(8),
    //     ]),
    //   },
    // );

    if (JSON.parse(localStorage.getItem("userInfo")) != undefined) {
      if (this.interval != undefined) {
        clearInterval(this.interval);
      }
      this.interval = setInterval(this.check.bind(this), 60000);

      this.loadinGral = true;
      const profile = JSON.parse(localStorage.getItem("userInfo"));
      const response = {
        success: true,
        data: profile,
      };
      this.app.setLogged(true);
      this.app.setUserInfo(profile);
      for (let i = 0; i < profile.module_init.length; i++) {
        switch (profile.module_init[i].modulo_inicio) {
          case "1":
            this.router.navigate(["reportes"]);
            break;

          case "2":
            this.router.navigate(["mantenimientos"]);
            break;

          case "3":
            this.router.navigate(["dashboard"]);
            break;

          case "6":
            this.router.navigate(["analisis"]);
            break;

          case "7":
            this.router.navigate(["sitios"]);
            break;

          case "10":
            this.router.navigate(["users"]);
            break;

          case "13":
            this.router.navigate(["refacciones"]);
            break;

          case 1:
            this.router.navigate(["reportes"]);
            break;

          case 2:
            this.router.navigate(["mantenimientos"]);
            break;

          case 3:
            this.router.navigate(["dashboard"]);
            break;

          case 6:
            this.router.navigate(["analisis"]);
            break;

          case 7:
            this.router.navigate(["sitios"]);
            break;

          case 10:
            this.router.navigate(["users"]);
            break;

          case 13:
            this.router.navigate(["refacciones"]);
            break;
          // ,{
          //   id:14,
          //   name:'Refacciones',
          //   show:false,
          //   icon:'icon-wrench menu-icon',
          //   childrens:null,
          //   route:'/refacciones'
          // }
        }
      }
      //this.loadinGral = false
    }
    this.loading = false;
  }

  check() {
    this._login.checkToken().subscribe((res: any) => {
      this._global.token = res.access;
      this._localstorage.sendToken("s");
      // localStorage.setItem('access', res.access);
    });
  }
  sendMessageUpdate(): void {
    this._localstorage.sendMessage(
      "Message from Home Component to App Component!"
    );
  }
  cargaMasiva(id) {
    this._firebase.getUser(id.toString()).subscribe((data: any) => {
      if (data) {
        if (data.messageText !== undefined) {
          if (data.messageText !== "") {
            if (
              data.messageText ==
              "Se ha completado la actualizacion de carga masiva de ordenes"
            ) {
              this._firebase.setUserOnBulkLoadFalse(id.toString());
            }
            Swal({
              title: "Carga Masiva",
              text: data.messageText,
              // type: 'error'
            });
            this._firebase.resetMessage(id.toString());
          }
        }
      }
    });
  }
  makeLogin() {
    const flag = true;

    // Swal({
    //   title: 'Guardando imagenes',
    //   text: 'Estamos comprimiendo tus imagenes, esto puede tardar unos segundos'
    // })
    // Swal.showLoading()
    if (this.flagInicio) {
      this.flagInicio = false;
      this._localstorage.sendMessage(
        "Message from Home Component to App Component!"
      );
      localStorage.setItem("remember", this.form.value["logedOn"]);
      const signin_data = {
        email: this.form.value.username,
        password: this.form.value["current-password"],
        device: this.device_info.device,
        device_os: this.device_info.device_os,
        device_os_version: this.device_info.device_os_version,
        rememberme: "false",
        navigator: this.device_info.navigator,
      };
      this.loading = true;
      this.showError = false;
      this.login.makeLogin(signin_data).subscribe(
        (response: any) => {
          if (response!.success) {
            this.flagInicio = true;
            let dataEncrypted = {
              username: btoa(response!.data["nombre"]),
              password: btoa(this.form.value["current-password"]),
            };
            localStorage.setItem(
              "userInfoEncrypted",
              JSON.stringify(dataEncrypted)
            );
            localStorage.setItem("userInfo", JSON.stringify(response.data));
            if (this.interval != undefined) {
              clearInterval(this.interval);
            }
            this.interval = setInterval(this.check.bind(this), 60000);
            this._login.checkToken().subscribe(
              (res: any) => {
                this._global.token = res.access;
                this._localstorage.sendToken("s");
                // localStorage.setItem('access', res.access);

                if (response.success) {
                  const dataInfo = {
                    os: this._global.detectBrowserName(),
                    tipo_dispositivo: "web",
                    usuario_id: response.data.usuario_id,
                  };
                  this._global.tracking(dataInfo).subscribe(
                    (res) => {
                      // console.log(res);
                    },
                    (err) => {
                      // console.error(err);
                    }
                  );

                  this.app.setLogged(true);
                  this.app.setUserInfo(response.data);
                  this.dataUser(
                    response.data.id,
                    response.data.usuario_id,
                    response.data.nombre_cliente
                  );
                  this._localstorage.sendLoginUser(
                    "Message from Home Component to App Component!"
                  );
                  this.cargaMasiva(response.data.usuario_id);
                  for (let i = 0; i < response.data.module_init.length; i++) {
                    switch (
                      parseInt(response.data.module_init[i].modulo_inicio)
                    ) {
                      case 1:
                        this.router.navigate(["reportes"]);
                        break;

                      case 2:
                        this.router.navigate(["mantenimientos/list"]);
                        break;

                      case 3:
                        this.router.navigate(["dashboard"]);
                        break;

                      case 6:
                        this.router.navigate(["analisis"]);
                        break;

                      case 7:
                        this.router.navigate(["sitios"]);
                        break;

                      case 10:
                        this.router.navigate(["users"]);
                        break;
                      case 13:
                        this.router.navigate(["refacciones"]);
                        break;
                    }
                  }
                } else {
                  this.loading = true;
                  this.showError = true;
                  this.msgError = response.msg;
                }
              },
              (error) => {
                Swal.close();
                localStorage.removeItem("userInfo");
                localStorage.removeItem("access");
                localStorage.removeItem("userInfoEncrypted");
                this.app.setLogged(false);
                this.router.navigate(["login"]);
              }
            );
          } else {
            this.flagInicio = true;
            this.loading = false;
            this.showError = true;
            this.msgError = response.msg;
            this.showMsg(response.msg);
          }
        },
        (err) => {
          this.flagInicio = false;
          this.loading = false;
          this.showError = true;
          this.msgError = err.msg;
          this.showMsg(err.msg);
        }
      );
    }
  }
  showMsg(msg = "") {
    this.snackBar.open(msg, "Cerrar", {
      duration: 2000,
    });
  }

  dataUser(id, usuario_id, nombre_cliente) {
    this.userService.getDetailUser(id, usuario_id).subscribe((res: any) => {
      if (res.success) {
        this.infoUser = {
          nombre: res.data.nombre,
          email: res.data.email,
          fecha_de_nacimiento: res.data.fecha_de_nacimiento,
          genero: res.data.genero,
          cliente: nombre_cliente,
          rol_id: res.data.rol_id,
          //locaciones_list: res.data.locaciones_list,
          plantas_list: res.data.plantas_list,
          //imagen_base64: res.data.imagen,
          fecha_validez: moment(res.data.fecha_validez).format("YYYY-MM-DD"),
          tipo_usuario: res.data.tipo_usuario == "interno" ? 1 : 2,
        };

        if (res.data.tipo_usuario == "interno") {
          this.infoUser.departamento_id = res.data.departamento_id;
          this.infoUser.puesto_id = res.data.puesto_id;
        }

        this.infoUser.plantas_list = this.infoUser.plantas_list.map((item) => {
          return item.planta_id;
        });

        if (res.data.primer_inicio_sesion == 1) {
          this.changePass(
            id,
            usuario_id,
            res.data.primer_inicio_sesion,
            this.infoUser,
            true
          );
        } else if (res.data.flag_format_password == 1) {
          this.changePass(
            id,
            usuario_id,
            res.data.primer_inicio_sesion,
            this.infoUser,
            true
          );
        }
      }
    });
  }

  changePass(id, usuario_id, primer_inicio, infoUser, type) {
    const dialogConfirm = this.dialog.open(ChangePassComponent, {
      width: "50%",
      disableClose: true,
      data: {
        id,
        usuario_id,
        primer_inicio,
        infoUser,
        typeFag: type,
      },
    });
  }
  goToLink() {
    this.flagPrivacy = this.flagPrivacy == false ? true : false;

    // this.dialog.open(PrivacyComponent, {
    //   data: {
    //     animal: 'panda',
    //   },
    // }).afterClosed().subscribe(res => {
    //   this.flagPrivacy = this.flagPrivacy == false ? true : false

    // })
  }
}
